export default "__VITE_PUBLIC_ASSET__d3f0152f__"